export function clearLocalStoragePreserving(groups: StorageGroup[]) {
  const prefixesToKeep = groups.flatMap(g => USE_CASES_TO_PRESERVE[g]);

  Object.keys(localStorage).forEach(key => {
    const shouldKeep = prefixesToKeep.some(prefix => key.startsWith(prefix));
    if (!shouldKeep) localStorage.removeItem(key);
  });
}

export const STORAGE_GROUPS = {
  reporting: 'reporting',
  redirect: 'redirect',
} as const;

const USE_CASES_TO_PRESERVE: Record<StorageGroup, string[]> = {
  reporting: ['report_columns_'],
  redirect: ['redirectPath'],
};

type StorageGroup = keyof typeof STORAGE_GROUPS;
